import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { updateStore, fetchStores } from '../../../../redux/storesSlice';
import { fetchUserBusinesses } from '../../../../redux/userBusinessesSlice';
import { notifyError, notifySuccess } from '../../../Notification';
import './accessStoreControl.css';

const DraggableMarker = ({ position, setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });

  return (
    <Marker
      draggable
      position={position}
      eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const newPos = marker.getLatLng();
          setPosition([newPos.lat, newPos.lng]);
        },
      }}
    />
  );
};

const EditStoreModal = ({ store, onClose }) => {
    console.log(`store: ${JSON.stringify(store)}`);
  const [storeName, setStoreName] = useState(store.name || '');
  const [googleReviewUrl, setGoogleReviewUrl] = useState(store.google_review_url || '');
  const [latitude, setLatitude] = useState(store.latitude || '');
  const [longitude, setLongitude] = useState(store.longitude || '');
  const [markerPosition, setMarkerPosition] = useState([parseFloat(store.latitude), parseFloat(store.longitude)]);

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.stores);
  const businessId = localStorage.getItem('selectedBusinessId');

  useEffect(() => {
    setLatitude(markerPosition[0]);
    setLongitude(markerPosition[1]);
  }, [markerPosition]);

  useEffect(() => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    if (!isNaN(lat) && !isNaN(lng)) {
      setMarkerPosition([lat, lng]);
    }
  }, [latitude, longitude]);

  const handleSubmit = () => {
    if (!storeName || !latitude || !longitude || !googleReviewUrl) {
      notifyError('Please fill in all fields.');
      return;
    }

    dispatch(updateStore({
      store_id: store.store_id,
      name: storeName,
      latitude,
      longitude,
      google_review_url: googleReviewUrl,
      business_id: businessId,
    }))
      .unwrap()
      .then(() => {
        notifySuccess(`Store "${storeName}" updated successfully`);
        dispatch(fetchStores(businessId));
        dispatch(fetchUserBusinesses(localStorage.getItem('user')));
        onClose();
      })
      .catch((err) => {
        notifyError(err || 'Failed to update store');
      });
  };

  useEffect(() => {
    if (error) {
      notifyError(error);
    }
  }, [error]);

  return (
    <div>
      {loading && <div className='loading'>Loading...</div>}
      <div className="add-store-form-wrapper">
        <div className="input-row">
          <div className="add-store-input-group">
            <div className="slide1-section-title">Edit Store Name:</div>
            <input
              className="add-business-input"
              type="text"
              value={storeName}
              onChange={(e) => setStoreName(e.target.value)}
            />
          </div>
          <div className="add-store-input-group">
            <div className="slide1-section-title">Google Review URL:</div>
            <input
              className="add-business-input"
              type="text"
              value={googleReviewUrl}
              onChange={(e) => setGoogleReviewUrl(e.target.value)}
            />
          </div>
        </div>

        <div className="input-row">
          <div className="add-store-input-group">
            <div className="slide1-section-title">Latitude:</div>
            <input
              className="add-business-input"
              type="text"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </div>
          <div className="add-store-input-group">
            <div className="slide1-section-title">Longitude:</div>
            <input
              className="add-business-input"
              type="text"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </div>
        </div>

        <MapContainer
          center={markerPosition}
          zoom={13}
          scrollWheelZoom={true}
          style={{ height: '300px', width: '100%', marginBottom: '1em' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <DraggableMarker position={markerPosition} setPosition={setMarkerPosition} />
        </MapContainer>

        <div className="add-business-btns-container">
          <button className="btn btn-primary" onClick={handleSubmit}>Update</button>
        </div>
      </div>
    </div>
  );
};

export default EditStoreModal;
